import React, { lazy, Suspense } from 'react';

import { ModalErrorBoundary } from '@services/errorService';
import { Loader } from '@sharedComponents/Loader';

import { FREE_DELIVERY_PRODUCTS_MODAL_SIZE } from '../components';
import { useCartPageContext } from '../context';

const FreeDeliveryProductsModal = lazy(
  () => import('../components/FreeDeliveryProductsModal/FreeDeliveryProductsModal'),
);

export const useFreeDeliveryProductsModal = (onModalClose: () => void): JSX.Element => {
  const {
    actions: { addProductToCart, removeFreeDeliveryProduct },
    settings: {
      freeDelivery,
      freeDeliveryGlobalFrom,
      freeDeliveryGlobalTo,
      minimalPriceLimit,
      freeDeliveryGlobalLimit,
    },
    state: {
      pricesSummary: { priceProductsSummary, discountWithoutDelivery },
      benefits,
    },
  } = useCartPageContext();
  return (
    <ModalErrorBoundary onError={onModalClose}>
      <Suspense fallback={<Loader height={FREE_DELIVERY_PRODUCTS_MODAL_SIZE} />} />
      <FreeDeliveryProductsModal
        addProductToCart={addProductToCart}
        deleteProduct={removeFreeDeliveryProduct}
        freeDelivery={freeDelivery}
        freeDeliveryGlobalFrom={freeDeliveryGlobalFrom}
        freeDeliveryGlobalTo={freeDeliveryGlobalTo}
        minimalPriceLimit={minimalPriceLimit}
        freeDeliveryGlobalLimit={freeDeliveryGlobalLimit}
        priceProductsSummary={priceProductsSummary}
        discountWithoutDelivery={discountWithoutDelivery}
        benefits={benefits}
      />
    </ModalErrorBoundary>
  );
};
